import React from 'react';
import PropTypes from 'prop-types';
import { DFPSlotsProvider } from 'react-dfp';
import Header from './base/Header';
import SeoSocial from './base/SeoSocial';
import { adSettings } from '~content/main.json';

import '~styles/base.scss';

const Layout = ({ children }) => (
  <DFPSlotsProvider
    dfpNetworkId={adSettings.networkId}
    adUnit={adSettings.unit}
  >
    <SeoSocial />
    <Header />
    <main id="content">
      {children}
    </main>
  </DFPSlotsProvider>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
